import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaPrompt } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaPrompt";
import { useTranslation } from "@coworker/locales";
import { Dropzone } from "./components/Dropzone/Dropzone";
import type { FileUploadConstraints } from "./components/Dropzone/types";
import styles from "./upload-media-modal.module.css";

type UploadMediaModalProps = FileUploadConstraints & {
  isOpen: boolean;
  onClose: () => void;
  onFilesSelected: (files: File[]) => void;
};

export const UploadMediaModal = ({
  isOpen,
  onClose,
  onFilesSelected,
  acceptedFileExtensions,
  maxFileSizeBytes,
  acceptedMimeTypes,
}: UploadMediaModalProps) => {
  const { t } = useTranslation();
  return (
    <FixaModal
      className={styles["modal"]}
      data-testid="upload-media-modal-dialog"
      handleCloseBtn={onClose}
      visible={isOpen}
    >
      <FixaPrompt
        className={styles["prompt"]}
        footer={null}
        header={
          <FixaModalHeader
            title={t("uploadString")}
            className={styles["header"]}
            ariaCloseTxt={t("closeActionString")}
            closeBtnClick={onClose}
          />
        }
        title=""
        titleId="upload-media-modal-dialog-title"
      >
        <Dropzone
          onFilesSelected={onFilesSelected}
          acceptedFileExtensions={acceptedFileExtensions}
          maxFileSizeBytes={maxFileSizeBytes}
          acceptedMimeTypes={acceptedMimeTypes}
        />
      </FixaPrompt>
    </FixaModal>
  );
};
